import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MarkdownModule, MarkdownService } from 'ngx-markdown'; 
import { HttpClientModule } from '@angular/common/http';
import { Location, CommonModule } from '@angular/common';


import { LanguageService } from '../../../services/language/language.service';


@Component({
  selector: 'app-markdown-viewer',
  standalone: true,
  imports: [
    CommonModule,
    MarkdownModule,
    HttpClientModule,
  ],
  providers: [
    MarkdownService
  ],
  templateUrl: './markdown-viewer.component.html',
  styleUrl: './markdown-viewer.component.css'
})
export class MarkdownViewerComponent {

  markdownUrl:string = ''
  signed:boolean = false

  languageCodeObservable:string = ''
  currentFile:string = ''

  /* 
  Se han marcado "ActivatedRoute", "Location" y el servicio "LanguageService" 
  como "readonly", porque se inyectan en el constructor y no se vuelven a modificar. 
  Esto es una buena práctica.
  */
  constructor(
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    private readonly languageService: LanguageService,
  ) {}


  

  ngOnInit(): void {
    // Subscribe to language service
    this.subscribeToLanguageService()
    // Recibir los paráemtros a traves de la url
    const file = this.route.snapshot.queryParams['file'];
    //const signed = this.route.snapshot.queryParams['signed'];
    if (file) {
      //this.markdownUrl = `/assets/markdown/${file}`;
      this.currentFile = file
      this.displayMarkdownDocument()
      // Modificar la URL para eliminar los parámetros de consulta
      //this.location.replaceState('/');
    }
  }



  displayMarkdownDocument(){
    if(this.currentFile != ''){
      this.markdownUrl = `/assets/markdown/${this.currentFile}_${this.languageCodeObservable.toUpperCase()}.md`;
    }
  }




  // Language service subscription to automatically detect language code changes based on the observable variable
  subscribeToLanguageService(){
    this.languageService.getCurrentLanguageCode().subscribe(async (currentLanguageCode:string) => {
      this.languageCodeObservable = currentLanguageCode
      this.displayMarkdownDocument()
    });
  }


}
